import { FontBaseUrl, ImgBaseUrl, VideoBaseUrl } from "../config.js";

export const Images = {
    SiteLogo: `${ImgBaseUrl}logo.png`,
    UserProfile: `${ImgBaseUrl}profile-img.png`,
    DashboardIcon: `${ImgBaseUrl}dashboard-icon.svg`,
    DashboardIconFill: `${ImgBaseUrl}dashboard-icon-fill.svg`,
    AnalysisIcon: `${ImgBaseUrl}analysis-icon.svg`,
    ProgressionIcon: `${ImgBaseUrl}progression.svg`,
    BiomarkerIcon: `${ImgBaseUrl}biomarkers-icon.svg`,
    InsightsIcon: `${ImgBaseUrl}insights.svg`,
    ReportsIcon: `${ImgBaseUrl}reports.svg`,
    ReportsIconFill: `${ImgBaseUrl}reports-fill.svg`,
    UserIcon: `${ImgBaseUrl}user.png`,
    PatientsIcon: `${ImgBaseUrl}patients.svg`,
    DocsIcon: `${ImgBaseUrl}active-cases.svg`,
    AlertIcon: `${ImgBaseUrl}high-risk.svg`,
    ScanIcon: `${ImgBaseUrl}scan-icon.svg`,
    UploadIcon: `${ImgBaseUrl}upload.svg`,
    DownloadIcon: `${ImgBaseUrl}download.svg`,
    DownloadIconDark: `${ImgBaseUrl}download-dark.svg`,
    ViewIcon: `${ImgBaseUrl}eye-icon.svg`,
    stable: `${ImgBaseUrl}stable.svg`,
    progressing: `${ImgBaseUrl}progressing.svg`,
    improving: `${ImgBaseUrl}improving.svg`,
    EyeIcon: `${ImgBaseUrl}eye-icon.svg`,
    CrossValidation: `${ImgBaseUrl}cross-validation.svg`,
    ExternalValidation: `${ImgBaseUrl}external-validation.svg`,
    ClinicalAgreement: `${ImgBaseUrl}clinical-agreement.svg`,
    ContinuousLearning: `${ImgBaseUrl}continuous-learning.svg`,
    EditIcon: `${ImgBaseUrl}pencil-white.svg`,
    FileIcon: `${ImgBaseUrl}file.svg`,
    CloseIcon: `${ImgBaseUrl}close-icon.svg`,
    Scan: `${ImgBaseUrl}scan.png`,
    
    BrainScan: `${ImgBaseUrl}brain-scan.nii`,
    Brain: `${ImgBaseUrl}brain.svg`,
    UsersIcon: `/assets/images/users-round.svg`,
    
}

export const Videos = {
    CustomSoftwareDevelopment: `${VideoBaseUrl}software-development.mp4`,

}

export const Fonts = {
    openSansBold: `${FontBaseUrl}openSans-bold.woff`,
    openSansBoldWoff2: `${FontBaseUrl}openSans-bold.woff2`,
    openSansExtraBold: `${FontBaseUrl}openSans-extrabold.woff`,
    openSansExtraBoldWoff2: `${FontBaseUrl}openSans-extrabold.woff2`,
    openSansLight: `${FontBaseUrl}openSans-light.woff`,
    openSansLightWoff2: `${FontBaseUrl}openSans-light.woff2`,
    openSansMedium: `${FontBaseUrl}openSans-medium.woff`,
    openSansMediumWoff2: `${FontBaseUrl}openSans-medium.woff2`,
    openSansRegular: `${FontBaseUrl}openSans-regular.woff`,
    openSansRegularWoff2: `${FontBaseUrl}openSans-regular.woff2`,
    openSansSemiBold: `${FontBaseUrl}openSans-semibold.woff`,
    openSansSemiBoldWoff2: `${FontBaseUrl}openSans-semibold.woff2`
};
